import { render, staticRenderFns } from "./ManterMinutaAlterar.vue?vue&type=template&id=6969c318&scoped=true&"
import script from "./ManterMinutaAlterar.vue?vue&type=script&lang=js&"
export * from "./ManterMinutaAlterar.vue?vue&type=script&lang=js&"
import style0 from "./ManterMinutaAlterar.vue?vue&type=style&index=0&id=6969c318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969c318",
  null
  
)

export default component.exports